export enum IconEnum{
	AddProcedure = 0,
	DeleteProcedure = 1,
	AddFavorite = 2,
	RemoveFavorite = 3,
}
